'use client'

import { useState } from 'react'

interface YouTubeFacadeProps {
  videoId: string
  title?: string
  className?: string
}

export default function YouTubeFacade({
  videoId,
  title = 'Video',
  className = '',
}: YouTubeFacadeProps) {
  const [active, setActive] = useState(false)

  if (active) {
    return (
      <iframe
        className={`w-full aspect-video ${className}`}
        src={`https://www.youtube.com/embed/${videoId}?rel=0&autoplay=1`}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    )
  }

  return (
    <button
      type="button"
      className={`relative w-full aspect-video cursor-pointer bg-black group ${className}`}
      onClick={() => setActive(true)}
      aria-label={`Play ${title}`}
    >
      {/* hqdefault is ~15 KB vs maxresdefault ~150 KB */}
      <img
        src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
        decoding="async"
        fetchPriority="low"
      />
      <div className="absolute inset-0 flex items-center justify-center">
        <svg
          viewBox="0 0 68 48"
          className="w-[68px] h-[48px] opacity-80 group-hover:opacity-100 transition-opacity"
        >
          <path
            d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55C3.97 2.33 2.27 4.81 1.48 7.74.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z"
            fill="#f00"
          />
          <path d="M45 24L27 14v20" fill="#fff" />
        </svg>
      </div>
    </button>
  )
}
